const config = {
    CHANNELS_HOST: 'https://channels-ws.moveo.ai',
    BRAIN_AVATAR: 'https://res.cloudinary.com/moveo-ai/image/upload/v1637720224/avatars/images_wgdkxm.jpg',
    TEST_INTEGRATION_ID: 'fake-integration-id',
};
export const getConfig = () => config;
